document.addEventListener('DOMContentLoaded', function() {
  /**
   * SlideVideo component
   */

  var SlideVideoContainer = class extends HTMLElement {
    connectedCallback() {
      this.xSlideshowCarousel = this.closest('slideshow-carousel');
      this.onDemandLoadVideos();
            
      if (this.xSlideshowCarousel) {
        this.handleVideoPlayback();
        this.xSlideshowCarousel.addEventListener('carousel:select', this.handleVideoPlayback.bind(this));
      }
    }
    
    /**
     * Handle nextSlide trigger when video ends
     * @param {VideoElement} video 
     * @returns void
     */
    videoPlaybackListener(video) {
      if (!video) return;

      const onEnded = () => {
        this.xSlideshowCarousel._dispatchEvent('control:next', this.xSlideshowCarousel._selectedIndex + 1);        
        video.removeEventListener('ended', onEnded);
      };

      video.addEventListener('ended', onEnded);
    }

    /**
     * Plays video when slide is reached and adds onEnd listener
     * @param {*} event 
     */
    handleVideoPlayback(event) {
      const selectedSlide = event?.detail?.slide ?? this.xSlideshowCarousel.selectedSlide;
      const selectedVideo = selectedSlide?.querySelector('video');
      
      if (selectedVideo) {
        if (selectedVideo.readyState >= 3) {
          selectedVideo.play();
        } else {
          selectedVideo.addEventListener('canplay', function() {
            this.play();
          });
        }
        this.videoPlaybackListener(selectedVideo);
      }
    }

    /**
     * Generic lazyloading of slideshow videos
     */
    onDemandLoadVideos() {
      const parentElement = this.closest('.slideshow__slide');
      const videoSources = this.querySelectorAll('source[data-src]');
      const videoElement = this.querySelector('video');

      const loadVideo = () => {
        videoSources.forEach(source => {
          source.src = source.dataset.src;
        });
        videoElement.load();
      };

      const clearVideo = () => {
        videoSources.forEach(source => {
          source.src = '';
        });
        videoElement.load();
      };

      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            if (parentElement.classList.contains('is-selected')) {
              loadVideo();
            } else {
              clearVideo();
            }
          }
        });
      });

      observer.observe(parentElement, { attributes: true });

      if (parentElement.classList.contains('is-selected')) {
        loadVideo();
      }
    }
  };
  
  if (!window.customElements.get('slide-video-container')) {
    window.customElements.define('slide-video-container', SlideVideoContainer);
  }
});